import React, {useEffect, useState} from 'react';
import {Button, Form, Popconfirm, Table, Select, Layout, Modal} from "antd";
import {getGridTableHeight} from '../Common/util';
import {csvDownload, excelDownload, EditableCell, EditableRow} from '../Common/function';
import axios from '../Common/axios';
import Papa from "papaparse";
import {postSaveTemplateUpload} from '../Common/api';
import Cookies from 'js-cookie';

const { Content } = Layout;
const {Option} = Select;

/** -------------------------------------------------------------------------- **/
const EditTable = ({data, columnData, reportId, infoType, isLoading, onClickSaveHandler, onReloadHandler, fullHeight = false}) => {

    // 변수 선언
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [deleteData, setDeleteData] = useState([]);
    let changeData = [];
    let excel_title = '위험';

    if(infoType == 'measure') {
      excel_title = '진단항목';
    } else if(infoType == 'suggest') {
      excel_title = '권고사항';
    } else if(infoType == 'threat') {
      excel_title = '위협(Threat)';
    } else if(infoType == 'rist') {
        excel_title = '위험(Risk)';
    } else if(infoType == 'corrective') {
        excel_title = '예외사항';
    } 

    const [uploading, setUploading] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    // State to store parsed data
    const [parsedData, setParsedData] = useState([]);
    //State to store table Column name
    const [tableRows, setTableRows] = useState([]);
    //State to store the values
    const [values, setValues] = useState([]);
    let titleName = excel_title+" 등록";
    /** -------------------------------------------------------------------------- **/
    useEffect(() => {
      setDataSource(data);
      setDeleteData([]);
    }, [data]);

    const defaultColumns = [
      {
        key: 'operation',
        width: '0px',
        defualt: '',
      },
      {
        title: 'delete',
        width: '100px',
        align: 'center',
        render: (_, record) =>
          dataSource.length >= 1 ? (
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.id)}>
              <a>Delete</a>
            </Popconfirm>
          ) : null,
      },
    ];

    const columns = [...columnData];

    // 삭제버튼 추가 (예외사항의 경우만)
    if (infoType === 'corrective') {
        defaultColumns.map((col) => {
            columns.push(col);
        });
    }

    const mergedColumns = columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
        }),
      };
    });

     // 행 추가
     const handleAdd = () => {
      let newData;
      if(infoType == 'measure') {
        newData = {
          operation: 'C',
          id: 0,
          report_id: reportId,
          measure_type: '',
          measure_cd: '',
          measure_nm: '',
          apply_action: '',
          important_grd: '',
          apply_time: '',
          cost_measure: null,
          risk_measure: null,
          difficulty_measure: null,
          risk_cd: '',
          threat_cd: '',
        };
      } else if(infoType == 'suggest') {
        newData = {
          operation: 'C',
          id: 0,
          report_id: reportId,
          measure_cd: '',
          asset_spec: '',
          suggest_desc: '',
        };
      } else if(infoType == 'threat') {
        newData = {
          operation: 'C',
          id: 0,
          report_id: reportId,
          threat_type: '',
          threat_cd: '',
          threat_nm: '',
          threat_desc: '',
          strength_grd: null,
          frequency_grd: null,
          threat_grd: null,
          threat_score: null,
          frequency_score: null,
          strength_score: null,
          threat_grd_score: null,
        };
      } else if(infoType == 'corrective') {
        newData = {
          operation: 'C',
          id: 0,
          report_id: reportId,
          asset_cd: '',
          measure_cd: '',
          current_status: '',
          result_cd: 'Y',
          corrective_desc: '',
        };
      }
      setDataSource([...dataSource, newData]);
  
      };

          
    // 행 삭제
    const handleDelete = (key) => {
      const newData = dataSource.filter((item) => item.id != key);
      setDataSource(newData);

      if(key != 0) {
        const delData = dataSource.filter((item) => item.id == key);
        delData[0].operation = 'D';
        setDeleteData(deleteData.concat(delData));
      }
    };

    //행 저장
    const handleSave = (row) => {
      const newData = [...dataSource];
      const index = newData.findIndex((item) => row.id == item.id);
      const item = newData[index];

      if(JSON.stringify(item) != JSON.stringify(row)) {
        row.operation = row.id=='0'?'C':'U';
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setDataSource(newData);
      }
    };

    useEffect(() => {

        //저장,수정 대상 추가
        const newData = dataSource.filter((item) => item.operation && item.operation != '');
        changeData = [];
        newData.map((record) => {
          if(record.operation && record.operation != '') {
            changeData = changeData.concat(record);
          }
        })

    }, [dataSource]);

    /** -------------------------------------------------------------------------- **/
    // 파일업로드
    const onChangeUploadHandler = (event) => {

      setShowUpload(true);
      setIsDataChange(false);
      // Passing file data (event.target.files[0]) to parse using Papa.parse
      Papa.parse(event.target.files[0], {
      header: true,
      skipEmptyLines: 'greedy',
      complete: function (results) {
          const rowsArray = [];
          const valuesArray = [];

          // Iterating data to get column name and their values
          results.data.map((d) => {
          rowsArray.push(Object.keys(d));
          valuesArray.push(Object.values(d));
          });

          // Parsed Data Response in array format
          setParsedData(results.data);

          // Filtered Column Names
          setTableRows(rowsArray[0]);

          // Filtered Values
          setValues(valuesArray);
        },
      });
    };
    

    // 파일업로드 저장
    const onClickFileSaveHandler = () => {

      setUploading(true);
      setIsDataChange(false);
      axios.post(postSaveTemplateUpload(), {
          reportId : reportId,
          infoType : infoType,
          parsedData : parsedData,
        }, {logType:'/create/VaBaseUpload/', logParam : reportId})
        .then((response) => {
          //console.log(response);
          setUploading(false);
          //Modal.info({title: "OK.", okText:"Close"});
          if(response.data.status == 'success') {
              Modal.info({title:titleName, content:response.data.message, okText:"Close", onOk() {
                  // 분석기준 재조회
                  onReloadHandler();
                  setShowUpload(false);
              }});
          } else {
              Modal.info({title:titleName, content:response.data, okText:"Close"});  
          }
      })
      .catch((error) => {
          setUploading(false);
          Modal.error({title:titleName, content:error.message, okText:"Close"});
      });
  };

  // 정보 변경시 재조회
  useEffect(() => {
    if(isDataChange) {
        setDataSource();
    }
  }, [isDataChange]);

    /** -------------------------------------------------------------------------- **/
    return (
        <div style={{height: fullHeight ? '100%' : 'auto', display: fullHeight ? 'flex' : 'block', flexDirection: 'column'}}>
                <table style={{width:'100%'}}><tbody>
                  <tr>
                    <td><div style={{marginLeft:'20px'}}>총 {dataSource?.length} 개</div></td>
                    
                    <td style={{textAlign:'right'}}>
                      <input
                        type="file"
                        name="file"
                        className='ant-btn-primary'
                        style={{
                          padding: '4px 15px',
                          opacity: fullHeight ? 0.5 : 1,
                          cursor: fullHeight ? 'not-allowed' : 'pointer'
                        }}
                        onChange={onChangeUploadHandler}
                        accept=".csv, .txt"
                        disabled={fullHeight}
                      />
                      {showUpload ? (
                        <Button type="default" onClick={()=>onClickFileSaveHandler()} disabled={fullHeight}>
                            Save
                          </Button>
                        ) : (
                          <>
                            {infoType === 'corrective' && (
                                <Button type="default" onClick={()=> handleAdd()} disabled={fullHeight}>
                                    Add a row
                                </Button>
                            )}
                            <Button type="default" onClick={()=>onClickSaveHandler(changeData.concat(deleteData))} disabled={fullHeight}>
                                    Save
                            </Button>
                            <Button type="default" onClick={()=> csvDownload(excel_title, dataSource, ['report_id'])} disabled={fullHeight}>
                                    Excel Download
                            </Button>
                          </>
                      )}
                    </td>



                  </tr></tbody>
                </table>
                {showUpload ? (
                <div className="section" id="uploadTable">      
                    <Content style={{ height: 450, backgroundColor: '#fff', overflow: 'scroll'}}>
                        <table>
                            <thead>
                            <tr>
                                {tableRows.map((rows, index) => {
                                return <th key={index}>{rows}</th>;
                                })}
                            </tr>
                            </thead>
                            <tbody>
                            {values.map((value, index) => {
                                return (
                                <tr key={index}>
                                    {value.map((val, i) => {
                                    return <td key={i}>{val}</td>;
                                    })}
                                </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </Content>
                </div>
            ) : (
                <Form form={form} component={false} style={{flex: fullHeight ? 1 : 'auto', display: fullHeight ? 'flex' : 'block', flexDirection: 'column'}}>
                  <Table
                        columns={mergedColumns}
                        dataSource={dataSource}
                        scroll={{y: fullHeight ? 'calc(100vh - 270px)' : getGridTableHeight(450)}}
                        loading={isLoading}
                        rowKey="id"
                        pagination={false}
                        bordered size={"small"}
                        style={{height: fullHeight ? 'auto' : getGridTableHeight(420)}}
                        showSorterTooltip={false}
                        components={{
                          body: {
                            row: EditableRow,
                            cell: EditableCell,
                          },
                        }}
                        rowClassName={() => 'editable-row'}
                  />
                </Form>
            )}
        </div>

    );
}
export default EditTable;